import styled from '@emotion/styled';

export const FooterText = styled.div`
  color: ${(props) => props.theme.color.blue.default};
`;

export const Container = styled.div`
  margin-top: 5px;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const Label = styled.div`
  font-weight: 500;
  flex-shrink: 1;
  font-size: 14px;
`;

export const Value = styled.div`
  margin-left: auto;
`;
